import type { DropdownMenuOption } from '@kandji-inc/nectar-ui';
import { memo } from 'react';
import type { CellThreatGroupProps } from 'src/features/edr/threat/threat.types';
import TableActionsDropdown from '../../../../common/components/ThreatListTable/TableActionsDropdown';
import getRowActionOptions from '../utils/get-row-action-options';

type ActionsCellProps = {
  actionOptions: DropdownMenuOption[];
};

export const ActionsCell = memo(({ actionOptions }: ActionsCellProps) => (
  <TableActionsDropdown options={actionOptions} testId="action-ellipsis" />
));

export const renderActionsCell = (info: CellThreatGroupProps<unknown>) => {
  const item = info?.row?.original;

  const actionOptions = getRowActionOptions(item);

  return <ActionsCell actionOptions={actionOptions} />;
};
